// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_identity_pool_id": "eu-west-1:ac56ca42-d583-4851-99dc-0e842fc55a04",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_RP238eErD",
    "aws_user_pools_web_client_id": "5iguuetft1issssof1o76jrqb5",
    "oauth": {}
};


export default awsmobile;
